import React, { useState, useRef, useEffect } from 'react';
import { apiAction } from '../../../actions';
import { API } from 'aws-amplify';
import { Button, Modal, Loading } from 'carbon-components-react';
import { Container } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import FormTransaction from '../../Form';
import translate from '../../../i18next/funcTranslateHelper';
import QueryString from 'qs';

export default function TransitionForm (props) {
  const { actions, origin, destination, transitionName, setForm, stages, configId } = props;
  const [open, setOpen] = React.useState(true);
  const [loading, setLoanding] = useState(false);
  const [message, setMessage] = useState(false);
  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  const [messageRes, setMessageRes] = useState('');
  const [currentStep, setCurrentStep] = useState(0);
  const [actionsFormData, setActionsFormData] = useState([]);
  const [formTitle, setFormTitle] = useState(transitionName);
  const [createFlowTemplates, setCreateFlowTemplates] = useState(null);
  const formRef = useRef();
  const submitFormButton = useRef();

  async function handleClose (flag) {
    setOpen(false);
    setForm(false);
  }

  useEffect(() => {
    // if the browser supports the w3c geo api
    if (navigator.geolocation) {
      // get the current position
      navigator.geolocation.getCurrentPosition(
        // if this was successful, get the latitude and longitude
        function (position) {
          setLat(position.coords.latitude.toString());
          setLon(position.coords.longitude.toString());
        },
        // if there was an error
        function (error) {
          console.error(error);
        }
      );
    }

    const additionalActions = actions.find(e => e.id === 'additionalActions');
    if (additionalActions && additionalActions.actions.includes('createFlow')) {
      getTemplates()
        .then(templates => {
          setCreateFlowTemplates(templates);
        })
        .catch(e => {
          let error = { errors: [{ message: '' }] };
          if (e.response.status === 403) {
            error = { errors: [{ message: translate('TransitionForm:getTemplatesError') }] };
          }
          setMessageRes(error);
          setMessage(true);
        });
    }
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!createFlowTemplates) return;

    const additionalActions = actions.find(e => e.id === 'additionalActions');
    const arr = [translate('TransitionForm:createFlowForm:chooseOption')];
    additionalActions.schema.properties.createFlow.properties.docTemplateId.enum = [''].concat(createFlowTemplates.doc.map(elm => elm.id));
    additionalActions.schema.properties.createFlow.properties.docTemplateId.enumNames = arr.concat(createFlowTemplates.doc.map(elm => elm.name));
    additionalActions.schema.properties.createFlow.properties.flowTemplateId.enum = [''].concat(createFlowTemplates.flow.map(elm => elm.templateId));
    additionalActions.schema.properties.createFlow.properties.flowTemplateId.enumNames = arr.concat(createFlowTemplates.flow.map(elm => elm.name));

    const _stages = stages.filter(e => e.id !== destination);
    additionalActions.schema.properties.createFlow.properties.targetStage.enum = [''].concat(_stages.map(elm => elm.id));
    additionalActions.schema.properties.createFlow.properties.targetStage.enumNames = arr.concat(_stages.map(elm => elm.name));
    additionalActions.schema.properties.createFlow.properties.errorStage.enum = [''].concat(_stages.map(elm => elm.id));
    additionalActions.schema.properties.createFlow.properties.errorStage.enumNames = arr.concat(_stages.map(elm => elm.name));

    additionalActions.schema.properties.createFlow.dependencies = {
      docTemplateId: {
        oneOf: createFlowTemplates.doc.map(elm => {
          const properties = JSON.parse(elm.schema).properties;
          delete properties.asset;

          return {
            properties: {
              docTemplateId: {
                enum: [elm.id]
              },
              docTemplateData: {
                type: 'object',
                title: translate('TransitionForm:createFlowForm:documentFormTitle'),
                properties: properties
              }
            }
          };
        })
      },
      flowTemplateId: {
        oneOf: createFlowTemplates.flow.map(elm => ({
          properties: {
            flowTemplateId: {
              enum: [elm.templateId]
            },
            flowTemplateData: {
              type: 'object',
              title: translate('TransitionForm:createFlowForm:flowFormTitle'),
              properties: elm.schema.properties,
              required: elm.schema.required
            }
          }
        }))
      }
    };
  }, [createFlowTemplates, actions, stages, destination, origin]);

  useEffect(function updateFormTitle () {
    if (currentStep === 0) {
      setFormTitle(transitionName);
    } else {
      setFormTitle(actions[currentStep].title);
    }
  }, [currentStep, transitionName, actions]);

  async function getTemplates () {
    const query = QueryString.stringify({
      flows: true
    });
    const urukRes = API.get('uruk-back', '/template');
    const firmaRes = API.get('admin-back', `/config/${configId}?${query}`);

    return Promise.all([urukRes, firmaRes])
      .then(arr => ({
        doc: arr[0],
        flow: arr[1].flows
      }));
  }

  function Message ({ props }) {
    return (
      <div>
        {props.message === 'OK' ? (
          <div>
            <h2>Acción realizada correctamente</h2>
            <p>Creada correctamente la transacción:</p>
            <p>{props.data[0].data.tx_hash}</p>
          </div>
        ) : (
          <div>
            <h2>Ha habido un error, inténtelo mas tarde</h2>
            <h3>{props.errors[0].message}</h3>
          </div>
        )}
      </div>
    );
  }

  async function onSubmit (formData) {
    if (formData.name && formData.assetId) {
      const navigatorItems = [
        'appName',
        'appVersion',
        'appCodeName',
        'cookieEnabled',
        'platform',
        'product',
        'userAgent',
        'language',
        'userLanguage',
        'systemLanguage'
      ];

      formData.deviceInfo = {};
      for (var item in navigator) {
        try {
          if (navigatorItems.indexOf(item) > -1) {
            formData.deviceInfo[item] = navigator[item];
          }
        } catch (e) { }
      }
      formData.lat = lat;
      formData.lon = lon;
    }

    actionsFormData[currentStep] = {
      id: actions[currentStep].id || 'CUSTOM',
      data: formData
    };
    setActionsFormData(actionsFormData);

    if (currentStep < actions.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      setLoanding(true);
      let result;
      try {
        result = await apiAction(actionsFormData, origin.stage, destination);
        setMessageRes(result);
        setMessage(true);
      } catch (result) {
        setMessageRes(result);
        setMessage(true);
      }
    }
  }

  return (
    <div>
      {loading ? (
        <Modal
          open={open}
          onRequestClose={() => handleClose(true)}
          passiveModal
          focusTrap={false}
          modalAriaLabel='true'
          aria-label='modal-transition-loading'
          aria-required='true'
          className='bx--modal-container-loading'
        >
          <div style={{ textAlign: 'center', height: '250px' }}>
            {!message ? (
              <>
                <Typography
                  variant='h4'
                  component='h4'
                  style={{ zIndex: '1000' }}
                  gutterBottom
                >
                  Cargando..
                </Typography>
                <Loading />
              </>
            ) : (
              <>
                <Message props={messageRes} />
                <DialogActions />
              </>
            )}
          </div>
        </Modal>
      ) : (
        <Modal
          open={open}
          onRequestClose={() => handleClose(false)}
          passiveModal
          focusTrap={false}
          modalAriaLabel='true'
          aria-label='modal-transition-not-loading'
          id='bx--modal-container-transition'
        >
          {message ? (
            <Message props={messageRes} />
          ) : (
            <Container maxWidth='xl'>
              <div style={{ fontSize: 26, fontWeight: 600 }}>
                {formTitle}
              </div>
              <FormTransaction
                formRef={formRef}
                formData={
                  actionsFormData[currentStep]
                    ? actionsFormData[currentStep].data
                    : currentStep === 0
                      ? origin.asset
                      : {}
                }
                schema={actions[currentStep].schema}
                uiSchema={actions[currentStep].uiSchema}
                onSubmit={onSubmit}
                submitFormButton={submitFormButton}
              />
              {currentStep !== 0 && (
                <Button
                  className='btx-transition'
                  type='button'
                  onClick={() => setCurrentStep(currentStep - 1)}
                  kind='secondary'
                >
                      Atrás
                </Button>
              )}
              {actions.length > 0 && currentStep < actions.length - 1 ? (
                <Button
                  className='btx-transition'
                  type='button'
                  onClick={() => submitFormButton.current.click()}
                >
                      Siguiente
                </Button>
              ) : (
                <Button
                  className='btx-transition'
                  type='submit'
                  onClick={async () => submitFormButton.current.click()}
                >
                        Enviar
                </Button>
              )}
            </Container>
          )}
        </Modal>
      )}
    </div>
  );
}
